import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../../../../../../utils/common'
import Button, {
  BUTTON_HEIGHT_24,
  BUTTON_HEIGHT_32,
} from '../../../../../../../Button'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../../../Icon'
import { IntegerInput } from '../../../../../../../Input'
import Text from '../../../../../../../Text'
import {
  MATCH_RULES_WEIGHT_MAX,
  MATCH_RULES_WEIGHT_MIN,
  QA_NAME_MATCH_RULES_ROW,
} from '../../ListingProfileApplicantsMatchRules.constants'
import { getMatchRulesCriterionLabel } from '../../ListingProfileApplicantsMatchRules.utils'

import * as styles from './ListingProfileApplicantsMatchRulesModalRow.module.css'

import CloseIcon from '../../../../../../../../icons/close.svg'
import InformationIcon from '../../../../../../../../icons/info.svg'

function ListingProfileApplicantsMatchRulesModalRow({
  criterion,
  hasRemove,
  hasWeight,
  isReadOnly,
  value,
  weight,
  weightHint,
  onChangeWeight,
  onRemove,
}) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_MATCH_RULES_ROW })}
      className={classNames(styles.ListingProfileApplicantsMatchRulesModalRow, {
        [styles.muted]: hasWeight && !Number(weight),
      })}
    >
      <span className={styles.label}>
        <Text>{getMatchRulesCriterionLabel({ criterion, t })}</Text>
        {criterion.measure_detail ? (
          <IconWithTooltip
            Icon={InformationIcon}
            className={styles.measure}
            size={ICON_HEIGHT_16}
            svgSize={ICON_HEIGHT_16}
            tooltip={criterion.measure_detail}
          />
        ) : null}
      </span>
      <span className={styles.value}>
        {value ?? (
          <Text isSecondary className={styles.valueText}>
            {criterion.listing_value}
          </Text>
        )}
      </span>
      <span className={styles.weight}>
        {hasWeight ? (
          <>
            <IntegerInput
              disabled={isReadOnly}
              height={BUTTON_HEIGHT_32}
              max={MATCH_RULES_WEIGHT_MAX}
              min={MATCH_RULES_WEIGHT_MIN}
              value={weight}
              wrapperClassName={styles.weightInput}
              onChange={onChangeWeight}
            />
            <Text isSecondary className={styles.weightHint}>
              {weightHint}
            </Text>
          </>
        ) : (
          <Text isSecondary>—</Text>
        )}
      </span>
      <span className={styles.remove}>
        {hasRemove && !isReadOnly ? (
          <Button.Text
            isGrey
            beforeIconProps={{ Icon: CloseIcon, height: ICON_HEIGHT_16 }}
            height={BUTTON_HEIGHT_24}
            tooltip={t('RentalPortal.MatchRulesRemoveKey')}
            onClick={onRemove}
          />
        ) : null}
      </span>
    </div>
  )
}

export default ListingProfileApplicantsMatchRulesModalRow
